import { render, staticRenderFns } from "./carouselMap.vue?vue&type=template&id=01264514&scoped=true"
import script from "./carouselMap.vue?vue&type=script&lang=js"
export * from "./carouselMap.vue?vue&type=script&lang=js"
import style0 from "./carouselMap.vue?vue&type=style&index=0&id=01264514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01264514",
  null
  
)

export default component.exports